<template>
	<page>
		<module>
			<view-list ref="view" :work-type="work_type" dynamic-field :field-sort="false" :view-config="auth('b_salary_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="部门">
							<c-select name="department_ids" async multiple @search="searchDepartment"></c-select>
						</m-search-item>
						<m-search-item label="账号">
							<c-input name="user_name"></c-input>
						</m-search-item>
						<m-search-item label="姓名">
							<c-select name="user_ids" async multiple @search="searchOutputUser"></c-select>
						</m-search-item>
						<m-search-item label="时间维度字段">
							<c-select name="date_field" :options="dateFieldOptions" :clear="false"></c-select>
						</m-search-item>
						<m-search-item label="时间范围">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="时间粒度">
							<c-select name="time_granule" :options="timeGranule" :clear="false"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_salary_export')" v-lock="lock('b_salary_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-config" @click="indeicatorFieldConfig()">指标配置</c-button>
				</template>

				<!--未审批计件工资-->
				<template #unapproved_piecework_salary="{data}">
					￥{{parseFloat(data.unapproved_piecework_salary).toFixed(2)}}
				</template>

				<!--未审批计时工资-->
				<template #unapproved_timework_salary="{data}">
					￥{{parseFloat(data.unapproved_timework_salary).toFixed(2)}}
				</template>

				<!--已审批计件工资-->
				<template #approved_piecework_salary="{data}">
					￥{{parseFloat(data.approved_piecework_salary).toFixed(2)}}
				</template>

				<!--已审批计时工资-->
				<template #approved_timework_salary="{data}">
					￥{{parseFloat(data.approved_timework_salary).toFixed(2)}}
				</template>

				<!--工资小计-->
				<template #salary_amount="{data}">
					￥{{parseFloat(data.salary_amount).toFixed(2)}}
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				work_type: 62,
				defaultSearchData: {
					time_granule: 'DAY',
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), 1).format('yyyy-MM-dd'),
					end_date: new Date(now.getFullYear(), now.getMonth() + 1, 0).format('yyyy-MM-dd')
				},
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['timeGranule', 'dateFieldOptions', 'orderStateDic', 'auditStateDic']),
			...mapGetters(['freeEdition'])
		},

		methods: {

			/*******搜索部门*****************/
			searchDepartment(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DEPARTMENT',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			//指标配置
			indeicatorFieldConfig(){
				this.globalDialog('indeicatorFieldConfig',{
					props: {
						work_type: this.work_type,
						view_id: this.$refs.view.getViewId()
					}
				}, this.updateTableList);
			},

			/****刷新列表****/
			updateTableList() {
				//刷新表头
				this.$refs.view.updateDynamicColumn();
				//刷新表数据
				this.$refs.view.update();
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>